<!--
 * @message: tab
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-09 13:15:28
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_Taber.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-08 13:53:52
 -->
<template>
  <v-tabs
    v-model="tab"
    :centered="centered"
    :background-color="backgroundColor"
    :grow="grow"
    :eager="false"
    :height="height"
    class="rounded-lg d-flex flex-column max-width"
    color="primary"
    :style="{ backgroundColor: backgroundColor }"
  >
    <v-tabs-slider color="primary" style="min-width: 50px"> </v-tabs-slider>
    <template v-for="(item, n) in items">
      <v-tab
        :key="n + 1"
        :ripple="false"
        :href="`#tab-${n + 1}`"
        class="text-capitalize text-body-2 text-no-wrap"
      >
        <v-badge
          color="primary"
          v-model="showBadge"
          :content="isLoading ? '...' : totalCount ? totalCount[n] : ''"
        >
          {{ closeTranslate ? item : $t(item) }}
          <template v-if="!showBadge && totalCount">
            <span
              v-if="!isLoading || tab != `tab-${n + 1}`"
              class="text--secondary"
            >
              ({{ totalCount[n] }})</span
            >
            <v-progress-circular
              v-else-if="isLoading && tab == `tab-${n + 1}`"
              :size="height ? Number(height) / 2 : 20"
              :width="2"
              color="primary"
              indeterminate
            />
          </template>
        </v-badge>
      </v-tab>
    </template>
    <!-- 筛选 -->
    <template v-if="!grow && !centered">
      <v-container
        fluid
        class="
          transparent
          py-0
          ma-0
          px-2
          d-flex
          align-center
          justify-end
          flex-row
        "
      >
        <template v-for="(item, n) in items">
          <slot :name="`filter-content-${n + 1}`" :filter="onFilter" />
        </template>
      </v-container>
    </template>
    <!-- 筛选 -->
    <v-tabs-items
      v-model="tab"
      continuous
      class="rounded-lg max-width transparent"
      :class="border ? '' : 'mt-3'"
      v-if="showTab"
    >
      <v-tab-item
        v-for="(item, n) in items"
        class="max-width"
        :key="`${n + 1}-content`"
        :value="`tab-${n + 1}`"
      >
        <!-- 滑块底部横线 -->
        <v-divider v-if="border"></v-divider>
        <v-card
          class="pa-0 rounded-lg"
          :elevation="0"
          overlap
          :class="contentBackground"
        >
          <v-card-text
            :class="(special ? 'pa-0 ' : ' pa-8 ') + contentBackground"
          >
            <slot :name="`content-${n + 1}`"></slot>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Taber",
  props: {
    centered: { default: false, type: Boolean },
    height: { default: undefined, type: [String, Number] },
    grow: { default: false, type: Boolean },
    border: { default: false, type: Boolean },
    totalCount: { default: undefined, type: [String, Array, Object] },
    special: { default: false, type: Boolean },
    showTab: { default: true, type: Boolean },
    showBadge: { default: false, type: Boolean },
    curTab: { default: "tab-1", type: String, required: true },
    backgroundColor: { default: "var(--taber-nav-color)", type: String },
    items: { default: [], type: [Array, String], required: true },
    closeTranslate: { default: false, type: Boolean }, //taber不翻译
    contentBackground: { default: "white", type: String },
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
  watch: {
    tab(val) {
      this.$emit("change", val);
    },
    curTab(val) {
      this.tab = val;
    },
  },
  created() {},
  mounted() {
    this.tab = this.curTab;
  },
  data() {
    return {
      tab: "tab-1",
    };
  },
  methods: {
    onFilter(page, perpage, data, tab) {
      const that = this;
      if (!page && !perpage) {
        if (tab !== undefined) {
          this.$emit("filter", null, tab);
        } else {
          this.$emit("filter", null);
        }
      } else {
        if (tab !== undefined) {
          this.$emit(
            "filter",
            { page: page, pagesize: perpage, data: data },
            tab
          );
        } else
          this.$emit("filter", { page: page, pagesize: perpage, data: data });
      }
    },
  },
};
</script>
<style scoped>
.v-tab.v-tab {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
